import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import { PrivacyPage } from './pages/privacy-page';
import { SupportPage } from './pages/support-page';
import { TermsPage } from './pages/terms-page';
import './state/persistence/test-hook';
import './styles/index.css';

const base = (import.meta.env.BASE_URL || '/').replace(/\/+$/, '');
const path = window.location.pathname.replace(/\/+$/, '');
const route = base ? path.replace(base, '') : path;

function Root() {
  if (route === '/privacy') return <PrivacyPage />;
  if (route === '/support') return <SupportPage />;
  if (route === '/terms') return <TermsPage />;
  return <App />;
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <Root />
  </StrictMode>,
);
